// extracted by mini-css-extract-plugin
export default {"location":"location_location__mXvfv","locationSpan":"location_locationSpan__lz5Zp"};